import orderBy from 'lodash-es/orderBy';
import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { logisticsActionCreators, LogisticsActionKeys, UpdateLoadRoute } from '..';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateLoadRoute } from '../logisticsApi';

function* updateLoadRouteSaga(action: UpdateLoadRoute) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(updateLoadRoute, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);
    if (response.value.value) {
      yield put(logisticsActionCreators.setRoute(response.value.value));
      yield put(
        logisticsActionCreators.setFinalDestination({
          loadNumber: action.payload.loadNumber,
          shipmentId: orderBy(action.payload.shipmentStopNumbers, x => x.stopNumber)[
            action.payload.shipmentStopNumbers.length - 1
          ].shipmentId
        })
      );
    }
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateLoadRoute() {
  yield takeEvery(LogisticsActionKeys.UPDATE_LOAD_ROUTE, updateLoadRouteSaga);
}
